import { createSlice } from '@reduxjs/toolkit'
import { makeRequest } from '../utils/apiUtils'
import { find } from 'lodash'

export const slice = createSlice({
  name: 'offerReward',
  initialState: {
    isLoading: {},
    isLoaded: {},
    offerRewards: {}
  },
  reducers: {
    loadRewardStart: (state, action) => {
      const { link } = action.additional;
      state.isLoading[link] = true;
      state.isLoaded[link] = false;
    },
    loadRewardSuccess: (state, action) => {
      const { link } = action.additional;
      state.isLoading[link] = false;
      state.isLoaded[link] = true;
      state.offerRewards[link] = find(action.response.aliexpressProduct, {url: link});
    },
    loadRewardFail: (state, action) => {
      const { link } = action.additional;
      state.isLoading[link] = false;
      state.isLoaded[link] = false;
      state.offerRewards[link] = null;
    }
  }
});

export const {
  loadRewardStart,
  loadRewardSuccess,
  loadRewardFail,

} = slice.actions;

export const selectRewardByLink = link => state => state.offerReward.offerRewards[link];
export const selectIsNotLoaded = link => state => !state.offerReward.isLoading[link] && !state.offerReward.isLoaded[link];
export const selectRewardIsLoading = link => state => state.offerReward.isLoading[link];

export function loadReward(link, signal) {
  return makeRequest(`/saduka/aliexpress/products?urls[]=${encodeURIComponent(link)}`, {
    types: [loadRewardStart.type, loadRewardSuccess.type, loadRewardFail.type],
    options: {
      credentials: 'include',
      signal
    },
    link
  })
}

export default slice.reducer;
